import { render } from "./ProfileContent.vue?vue&type=template&id=49f20f88&scoped=true"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"

import "./ProfileContent.vue?vue&type=style&index=0&id=49f20f88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f20f88"]])

export default __exports__